/* Comportamientos de la plantilla RailVale formato Beautylulus (copiados del clon local). */
(function () {
  if (window.rvblListo) return;
  window.rvblListo = true;
  var desk = matchMedia('(min-width:990px)');

  function carrusel(cont, pista, porVista, alIr) {
    var items = [].slice.call(pista.children), i = 0, pts = cont.querySelector('.rvbl-puntos');
    if (!items.length) return { ir: function () {} };
    function max() { return Math.max(0, items.length - porVista()); }
    function puntos() {
      if (!pts || pts.children.length === max() + 1) return;
      pts.innerHTML = '';
      for (var k = 0; k <= max(); k++) {
        var s = document.createElement('span');
        (function (n) { s.onclick = function () { ir(n); }; })(k);
        pts.appendChild(s);
      }
    }
    function ir(n) {
      i = Math.max(0, Math.min(max(), n));
      var gap = parseFloat(getComputedStyle(pista).columnGap) || 0;
      pista.style.transform = 'translateX(' + (-i * (items[0].getBoundingClientRect().width + gap)) + 'px)';
      if (pts) [].forEach.call(pts.children, function (s, k) { s.classList.toggle('on', k === i); });
      [].forEach.call(cont.querySelectorAll('.rvbl-prev'), function (b) { b.disabled = i === 0; });
      [].forEach.call(cont.querySelectorAll('.rvbl-next'), function (b) { b.disabled = i === max(); });
      if (alIr) alIr(i);
    }
    [].forEach.call(cont.querySelectorAll('.rvbl-prev'), function (b) { b.addEventListener('click', function () { ir(i - 1); }); });
    [].forEach.call(cont.querySelectorAll('.rvbl-next'), function (b) { b.addEventListener('click', function () { ir(i + 1); }); });
    var x0 = null, y0 = null, zona = pista.parentNode;
    zona.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    zona.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) ir(i + (dx < 0 ? 1 : -1));
      x0 = null;
    }, { passive: true });
    function rehacer() { puntos(); ir(i); }
    addEventListener('resize', rehacer); rehacer();
    return { ir: ir, actual: function () { return i; } };
  }

  function galeria(gal) {
    var slides = gal.querySelector('.rvbl-gal__slides'), fila = gal.querySelector('.rvbl-minis__fila');
    if (slides.children.length < 2) { gal.classList.add('rvbl-gal--uno'); return; }
    [].forEach.call(slides.children, function (m, k) {
      var b = document.createElement('button'); b.type = 'button'; b.className = 'rvbl-mini';
      var src = m.getAttribute('data-mini') || m.currentSrc || m.src || '';
      b.innerHTML = '<img src="' + src + '" alt="" loading="lazy">';
      b.onclick = function () { g.ir(k); };
      fila.appendChild(b);
    });
    var g = carrusel(gal, slides, function () { return 1; }, function (i) {
      [].forEach.call(fila.children, function (b, k) { b.classList.toggle('on', k === i); });
      var vis = Math.floor((fila.parentNode.clientWidth + 10) / 125);
      var ini = Math.max(0, Math.min(fila.children.length - vis, i - Math.floor(vis / 2)));
      fila.style.transform = 'translateX(' + (-ini * 125) + 'px)';
    });
  }

  function slider(sl) {
    var so = sl.querySelector('.rvbl-slider__sobre'), li = sl.querySelector('.rvbl-slider__linea'), ci = sl.querySelector('.rvbl-slider__circulo');
    function pos(x) { var r = sl.getBoundingClientRect(), p = Math.max(0, Math.min(1, (x - r.left) / r.width)) * 100; so.style.width = p + '%'; li.style.left = p + '%'; ci.style.left = p + '%'; }
    function ancho() { sl.style.setProperty('--w', sl.getBoundingClientRect().width + 'px'); }
    ancho(); addEventListener('resize', ancho);
    var arr = false;
    sl.addEventListener('pointerdown', function (e) { arr = true; sl.setPointerCapture(e.pointerId); pos(e.clientX); });
    sl.addEventListener('pointermove', function (e) { if (arr) pos(e.clientX); });
    sl.addEventListener('pointerup', function () { arr = false; });
  }

  function pasos(lin) {
    var rel = lin.querySelector('.rvbl-linea__relleno'), ps = [].slice.call(lin.querySelectorAll('.rvbl-paso'));
    ps.forEach(function (p, i) { p.classList.add('fuera'); p.style.transitionDelay = (i * 0.1) + 's'; });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) { es.forEach(function (e) { e.target.classList.toggle('fuera', !e.isIntersecting); }); }, { threshold: 0.2, rootMargin: '0px 0px -100px 0px' });
      ps.forEach(function (p) { io.observe(p); });
    } else ps.forEach(function (p) { p.classList.remove('fuera'); });
    function llenar() {
      var r = lin.getBoundingClientRect(), alto = r.height - 30, h = Math.max(0, Math.min(alto, innerHeight * 0.6 - r.top - 30));
      rel.style.height = h + 'px';
      ps.forEach(function (p) { p.classList.toggle('visto', p.offsetTop <= h + 30); });
    }
    var tick = false;
    addEventListener('scroll', function () { if (!tick) { requestAnimationFrame(function () { llenar(); tick = false; }); tick = true; } }, { passive: true });
    addEventListener('resize', llenar); llenar();
  }

  function irAlFormulario() {
    var f = document.getElementById('rvbl-form');
    if (f) f.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function iniciar() {
    document.querySelectorAll('.rvbl-gal').forEach(galeria);
    document.querySelectorAll('[data-rvbl-carrusel]').forEach(function (c) {
      var n = c.getAttribute('data-rvbl-carrusel').split(',').map(Number);
      carrusel(c, c.querySelector('.rvbl-pista'), function () { return desk.matches ? n[1] : n[0]; });
    });
    document.querySelectorAll('.rvbl-slider').forEach(slider);
    document.querySelectorAll('.rvbl-linea').forEach(pasos);
    document.querySelectorAll('.rvbl-acc__q').forEach(function (q) {
      q.addEventListener('click', function () {
        var a = q.nextElementSibling, ab = !q.parentNode.classList.contains('abierto');
        q.parentNode.classList.toggle('abierto', ab);
        a.style.maxHeight = ab ? a.scrollHeight + 'px' : '0px';
      });
    });
    document.querySelectorAll('[data-rvbl-al-formulario]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); irAlFormulario(); });
    });
    var fija = document.querySelector('.rvbl-fija'), form = document.getElementById('rvbl-form');
    if (fija && form && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        fija.classList.toggle('ver', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(form);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
